import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import EmailViewer from "@/components/email/EmailViewer";
import EmailHeader from "./EmailHeader";
import { type Email } from "@/types/email";

interface InitialEmailViewProps {
  email: Email;
  isGenerating: boolean;
  selectedAssistant: string;
  onGenerate: () => void;
}

const InitialEmailView = ({ 
  email, 
  isGenerating, 
  selectedAssistant, 
  onGenerate 
}: InitialEmailViewProps) => {
  return (
    <div className="space-y-4">
      <EmailHeader 
        subject={email.subject}
        emailSent={false}
      />
      <EmailViewer email={email} hideSubject={true} />
      <Button 
        className="w-full" 
        onClick={onGenerate}
        disabled={isGenerating || !selectedAssistant}
      >
        <Sparkles className="h-4 w-4 mr-2" />
        {isGenerating ? "Generating..." : "Generate Response"}
      </Button>
    </div>
  );
};

export default InitialEmailView;